// var CryptoJS = require("crypto-js");

let publicFun = {
    // 验证手机号
    isPhoneNo: function (phone) {
        var pattern = /^[0-9]*$/;
        return pattern.test(phone);
    },
    isEmail (s) {
        return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
    },
    isIDCard (card) {
        var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; 
        return reg.test(card)
    }, 
    formateDate: function (date, fm) {
        if (/(y+)/.test(fm)) {
            fm = fm.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        var o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
        }
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fm)) {
                let str = o[k] + ''
                fm = fm.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
            }
        }
        return fm
    },
    removeDuplicatedItem: function (ar) {
        var ret = [];
        for (var i = 0, j = ar.length; i < j; i++) {
            if (ret.indexOf(ar[i]) === -1) {
                ret.push(ar[i]);
            }
        }

        return ret;
    },
    getYesterday() {//获取昨天日期
        let day1 = new Date();
        day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
        let s1 = day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
        return s1;
    },
    //时间戳转换成具体时间
    getLocalTime(timestamp) {//   格式 2000-03-08 12:15:45
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        return Y + M + D + h + m + s;
    },
    //时间戳转换成具体时间  格式   2018.10.01
    getLocalTime2(timestamp) {//   格式 2000-03-08 12:15:45
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '.';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '.';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '';
        return Y + M + D;
    },
    //时间戳转换成具体时间  格式   01-02 16:00
    getLocalTime3(timestamp) {//   
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
        return M + D + h + m;
    },
    //时间戳转换成具体时间  格式   01-02 16:00
    getLocalTime4(timestamp,connect) {//   
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + connect;
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + connect;
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
        return Y + M + D + h + m;
    },

    //获取当前日期方法
    getNowFormatDate() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
    getBeforeWeek(d) {//前七天
        d = new Date(d);
        d = +d - 1000 * 60 * 60 * 24 * 6;
        d = new Date(d);
        var year = d.getFullYear();
        var mon = d.getMonth() + 1;
        var day = d.getDate();
        let s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
        return s;
    },
    getBeforeMonth(d) {//前一个月
        d = new Date(d);
        d = +d - 1000 * 60 * 60 * 24 * 29;
        d = new Date(d);
        var year = d.getFullYear();
        var mon = d.getMonth() + 1;
        var day = d.getDate();
        let s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
        return s;
    },
    setCookie(c_name,value,expiredays) {
        var exdate=new Date()
        exdate.setDate(exdate.getDate()+expiredays)
        document.cookie=c_name+ "=" +escape(value)+
        ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
    },
    getCookie(c_name) {
        if (document.cookie.length>0){
            var c_start=document.cookie.indexOf(c_name + "=")
            if (c_start!=-1)
                { 
                c_start=c_start + c_name.length+1 
                var c_end=document.cookie.indexOf(";",c_start)
                if (c_end==-1) c_end=document.cookie.length
                return unescape(document.cookie.substring(c_start,c_end))
                } 
            }
            return ""
    },
    is_weixin(){
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        } else {
            return false;
        }
    }


}

function padLeftZero(str) {
    return ('00' + str).substr(str.length)
}

//判断是否微信登陆
function isWeiXin() {
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == 'micromessenger') {
		return true;
	} else {
		return false;
	}
}

import Vue from 'vue'
import axios from 'axios'
import qs from 'qs';
var axiosApi = {
    request: function (url, param, method,callback, errCallback) {
        if (method == 'PUT' || method == 'POST' || method == 'PATCH') {
            return axios({
                method: method,
                url: url,
                data: param,
                timeout: 600000,
                headers: {
                    'Content-type': 'application/json;charset=UTF-8'
                }
            }).then((res) => {
                if (res.data.code == 0) {
                    callback(res.data)
                } else {
                    console.log(res);
                    Vue.$vux.toast.text(res.data.msg)
                    errCallback && errCallback();
                }
            })
            .catch((error) => {
                console.log(error);
                Vue.$vux.loading.hide();
                errCallback && errCallback();
                // Vue.$vux.toast.text('服务器异常')
                Vue.$vux.toast.text(JSON.stringify(error))
                // Vue.$vux.alert.show({
                //     content: JSON.stringify(error),
                //     onShow () {
                //         console.log('Plugin: I\'m showing')
                //     },
                //     onHide () {
                //         console.log('Plugin: I\'m hiding')
                //     }
                // })

            })
        } else {
            return axios({
                method: method,
                url: url,
                params: param,
                headers: {
                    'Content-type': 'application/json;charset=UTF-8'
                }
            }).then((res) => {
                if (res.data.code == 0) {
                    callback(res.data)
                } else {
                    Vue.$vux.toast.text(res.data.msg)
                }
            })
            .catch((error) => {
                errCallback && errCallback();
                console.log(error);
                Vue.$vux.toast.text('服务器异常')
            })
        }
      
    },
    cancel() {
        axios.CancelToken.source().cancel();
    },
    upload(url, param, callback, errCallback) {
        return axios({
            method: 'POST',
            url: url,
            data: param,
            timeout: 600000,
            headers: {
                'Content-type': 'multipart/form-data'
            },
        }).then((res) => {
            if (res.data.code == 0) {
                callback(res.data)
            } else {
                Vue.$vux.toast.text(res.data.msg)
                errCallback && errCallback();
            }
        })
        .catch((error) => {
            console.log(error);
            errCallback && errCallback();
            // Vue.$vux.toast.text('服务器异常')
            Vue.$vux.alert.show({
                content: JSON.stringify(error),
                onShow () {
                    console.log('Plugin: I\'m showing')
                },
                onHide () {
                    console.log('Plugin: I\'m hiding')
                }
            })
        })
    }
}
export {
    publicFun,
    axiosApi
}




// WEBPACK FOOTER //
// ./src/assets/js/publicFunc.js